"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const PulseBryntumGrid_1 = __importDefault(require("@pcs/pulse-components/PulseBryntumGrid"));
const clsx_1 = __importDefault(require("clsx"));
const helpers_1 = require("jsAssets/views/asset-detail/helpers");
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const helper_1 = require("../../helper");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const view_linked_tasks_types_1 = require("./view-linked-tasks-types");
const limit = 5;
const DEFAULT_AJAX_STORE_PARAMS = {
    jq: view_linked_tasks_types_1.LINKED_TASKS_JQ,
};
const columnConfigs = [
    {
        field: 'ticket_id',
        text: 'TASK ID',
        align: 'center',
        width: 90,
        sortable: false,
        resizable: false,
        renderer: (record) => {
            const source = record.record.data;
            return source.ticket_id ? react_1.default.createElement("span", null,
                "#",
                source.ticket_id) : react_1.default.createElement(react_1.default.Fragment, null);
        },
    },
    {
        field: 'ticket_title',
        text: 'TASK TITLE',
        width: 310,
        draggable: false,
    },
    {
        field: 'project',
        text: 'PROJECT',
        align: 'left',
        width: 180,
        draggable: false,
        renderer: (record) => {
            const source = record.record.data;
            return source ? react_1.default.createElement("span", null, source.job.jobTitle) : react_1.default.createElement(react_1.default.Fragment, null);
        },
    },
    {
        field: 'status',
        text: 'STATUS',
        width: 130,
        draggable: false,
        renderer: (record) => {
            const source = record.record.data;
            if (source.ticketStatus) {
                return (react_1.default.createElement(pulse_components_1.PulseChip, { label: source.ticketStatus.name, color: source.ticketStatus.hexcolor, maxWidth: 100, classes: {
                        root: styles_modules_less_1.default['status-chip'],
                    }, PulseTooltipProps: {
                        TippyProps: {
                            appendTo: document.body,
                        },
                    } }));
            }
            return react_1.default.createElement(react_1.default.Fragment, null);
        },
    },
    {
        field: 'view_btn',
        region: 'right',
        text: '',
        align: 'center',
        hideable: false,
        sortable: false,
        draggable: false,
        resizable: false,
        minWidth: 145,
        cellCls: styles_modules_less_1.default['view-btn'],
        renderer: (record) => {
            const source = record.record.data;
            if (source) {
                return (react_1.default.createElement(pulse_components_1.PulseButton, { classes: [styles_modules_less_1.default['go-to-task-btn']], label: "GO TO TASK", icon: true, iconClasses: {
                        icon: 'fal fa-link',
                        root: styles_modules_less_1.default['go-to-task__icon'],
                    }, onClick: () => {
                        window.open(`${helpers_1.URLS.app}passport/${source.job.jobId}/tasklist/${source.ticket_id}`);
                    } }));
            }
            return react_1.default.createElement(react_1.default.Fragment, null);
        },
    },
];
const ViewLinkedTasksModal = ({ isNoLinkedTasks, isOpen, handleCloseModal, roundId, }) => {
    const gridRef = (0, react_1.useRef)(null);
    const AJAX_STORE_CONFIG = (0, react_1.useMemo)(() => {
        return {
            readUrl: `${helpers_1.URLS.app}api/rounds/${roundId}/tickets?include=ticketStatus,job`,
            autoLoad: true,
            params: DEFAULT_AJAX_STORE_PARAMS,
            pageSize: limit,
            pageParamName: 'page[number]',
            pageSizeParamName: 'page[per_page]',
            responseTotalProperty: 'page.total',
            listeners: {
                sort: ({ source: ajaxStore, sorters }) => {
                    // Handle sorting
                    if (ajaxStore) {
                        const { params: currentParams } = ajaxStore;
                        const { ascending, field } = sorters[0];
                        if (field) {
                            const params = {
                                ...currentParams,
                                sort: ascending
                                    ? (0, lodash_1.get)(view_linked_tasks_types_1.FIELDS_TO_COLUMNS, field, '')
                                    : `-${(0, lodash_1.get)(view_linked_tasks_types_1.FIELDS_TO_COLUMNS, field, '')}`,
                            };
                            ajaxStore.setConfig({ params });
                            ajaxStore.load({ params });
                        }
                    }
                },
            },
        };
    }, [roundId]);
    const searchLinkedTask = (text) => {
        const gridInstance = gridRef.current.instance;
        if (gridInstance) {
            const { store: gridAjaxStore } = gridInstance;
            const params = {
                ...gridAjaxStore.params,
                ...(0, helper_1.filterParams)({
                    title: text,
                }),
            };
            gridAjaxStore.setConfig({ params });
            gridAjaxStore.loadPage(1);
        }
    };
    const debounceSearchFn = (0, react_1.useCallback)((0, lodash_1.debounce)(searchLinkedTask, 500), []);
    const handleChangeInput = (e) => {
        debounceSearchFn(e.target.value);
    };
    return (react_1.default.createElement(pulse_components_1.PulseModalBase, { open: isOpen, classes: {
            dialog: {
                paper: styles_modules_less_1.default['modal-root'],
            },
        }, PulseModalHeaderProps: {
            classes: {
                root: styles_modules_less_1.default['modal-header__root'],
                titleContainer: styles_modules_less_1.default['modal-header__ctn'],
                titlePrimary: styles_modules_less_1.default['modal-header__title'],
                closeBtn: styles_modules_less_1.default['modal-header__closeBtn'],
            },
            headerIconClasses: (0, clsx_1.default)('fal fa-link', styles_modules_less_1.default['modal-header__icon']),
        }, footer: false, onModalClose: handleCloseModal, headerPrimaryText: "View linked tasks" }, isNoLinkedTasks ? (react_1.default.createElement("div", { className: styles_modules_less_1.default['linked-tasks__no-task'] },
        react_1.default.createElement("i", { className: "fal fa-link" }),
        react_1.default.createElement("p", { className: styles_modules_less_1.default['no-linked-task__title'] }, "NO TASKS LINKED TO THIS REVIEW"),
        react_1.default.createElement("p", { className: styles_modules_less_1.default['no-linked-task__description'] }, "You can link tasks by simply selecting the 'Link Reviews' button within the Task you wish to link, and then selecting this Review."))) : (react_1.default.createElement("div", { className: styles_modules_less_1.default['linked-tasks__ctn'] },
        react_1.default.createElement(pulse_components_1.PulseInput, { InputBaseProps: {
                onChange: handleChangeInput,
                classes: {
                    root: styles_modules_less_1.default['filter-input__root'],
                    input: styles_modules_less_1.default['filter-input__input'],
                },
                placeholder: 'Search for Task or Project...',
                startAdornment: (react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-search', styles_modules_less_1.default['filter-input__icon']) })),
            } }),
        (0, react_1.useMemo)(() => (react_1.default.createElement(PulseBryntumGrid_1.default, { ref: gridRef, gridProps: {
                columns: columnConfigs,
            }, ajaxStoreConfig: AJAX_STORE_CONFIG, paginate: true })), [])))));
};
exports.default = ViewLinkedTasksModal;
